<template>
  <div class="podcast-episode">
    <table>
        <tr>
            <td class="image-td">
                <a :href="youtube" target="_blank">
                    <img :src="this.thumbnail_base_url+'J_J_E'+episodeNumber+'_T.png'" class="episode-image">
                </a>
            </td>
            <td class="copy-td">
                <div class="episode-copy">
                    <h3>{{title}}</h3>
                    <span class="subtitle">{{subtitle}}</span>
                    <p class="episode-description">{{description}}</p>
                </div>
            </td>
        </tr>
    </table>
    <div class="row">
        <div class="col-12">
            <audio controls class="podcast-audio-controls">
                <source :src="this.audio_base_url+'J_J_E'+episodeNumber+'_A.mp3'" type="audio/mpeg"> Your browser does not support the audio element.</audio>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Podcast',
  props: ['description', 'youtube', 'title', 'subtitle', 'episodeNumber'],
  data () {
    return {
      audio_base_url: '../podcast/mp3/',
      thumbnail_base_url: '../podcast/png/'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.episode-image {
  object-fit: cover;
  width: 100%;
  min-width: 50px;
  min-height: 50px;
  max-width:300px;
  max-height:300px;
  border-radius: 9px;
  margin: 20px;
  margin-bottom: 10px;
}
.podcast-audio-controls {
  width: 96%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2%;
  margin-right: 2%;
}

.podcast-episode {
  background-color: white;
  border-radius: 30px;
  box-shadow: 0px 5px 20px gray;
  padding: 20px;
  margin: 40px;
}

.episode-copy {
  padding-left:40px;
  padding-right:40px;
  text-align:left
}

.image-td{
    width:30%;
}

.copy-td{
    width:70%;
}
table{
    width:100%;
}

.subtitle{
    color:lightslategray;
    font-style:italic;
}
h3{
    margin-bottom:5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Podcast.vue